export default __webpack_public_path__ + "static/media/302.45181fd7.jpg";